import { FC, useRef, useState, useCallback, useMemo } from 'react'
import * as styles from 'components/features/pfm/LazyRender/LazyRender.styl'
import * as cn from 'classnames'
import { VisibilityHandler } from 'components/features/pfm/VisibilityHandler/VisibilityHandler'

type LazyRenderProps = {
  permanent?: boolean
  className?: string
  margin?: number
  inverse?: boolean
}

export const LazyRender: FC<LazyRenderProps> = (props) => {
  const { className, margin, permanent, children, inverse = false } = props

  const [shouldRender, setShouldRender] = useState(false)
  const shouldRenderRef = useRef(false)
  shouldRenderRef.current = shouldRender

  const handleVisibilityChange = useCallback<(isVisible: boolean | null) => void>((isVisible) => {
    const notSupported = isVisible === null
    const nextShouldRender = notSupported || isVisible !== inverse

    if (shouldRenderRef.current !== nextShouldRender) {
      setShouldRender(nextShouldRender)
    }
  }, [inverse])

  const options = useMemo(() => {
    if (margin) {
      return {
        rootMargin: `${ margin }px`,
      }
    }

    return undefined
  }, [margin])

  return (
    <VisibilityHandler
      className={ cn(styles.container, className) }
      disabled={ permanent && shouldRender }
      onChange={ handleVisibilityChange }
      options={ options }
    >
      { shouldRender && children }
    </VisibilityHandler>
  )
}
